import React, {useEffect, useState} from "react";
import axios from "config/axiosConfig";
import {Link, useSearchParams, useNavigate} from "react-router-dom";
import {Pagination} from "page/util/Pagination";
import {formatBusinessNumber, formatDate, formatPhoneNumber} from "page/util/helpers";

function Main() {
    const [searchParams, setSearchParams] = useSearchParams();
    const [paginationDto, setPaginationDto] = useState();
    const [contents, setContents] = useState([]);

    const page = searchParams.get('page') || "1";
    const bizName = searchParams.get('bizName');

    const navigate = useNavigate();

    const requestSearch = (e) => {
        const params = {};
        params.page = page;
        if (bizName !== null && bizName !== undefined && bizName !== '' && bizName.trim() !== '') {
            params.bizName = bizName;
        }

        axios.get(`/admin/batch-logs/edi0004`, { params: params })
            .then((res) => {
                setPaginationDto(res.data);
                setContents(res.data.content);
            });
    }

    const setPage = (page) => {
        searchParams.set('page', page);
        setSearchParams(searchParams)
    }

    function formatYearMonth(yyyymm: string): string {
        if (yyyymm.length !== 6) return yyyymm; // 길이 검증
        const year = yyyymm.slice(0, 4);
        const month = yyyymm.slice(4, 6);
        return `${year}년 ${month}월`;
    }

    useEffect(() => {
        requestSearch();
    }, [page]);

    return (
        <div className="App">
            <div className="wrapper">
                <div className="content-wrapper" style={{marginLeft: '0px'}}>
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item active">4대보험 - EDI0004 동기화 이력</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">

                                    <div className="card">
                                        <div className="card-tools" style={{marginTop: '40px'}}>
                                            <div className="form-group row" style={{float: "right"}}>

                                                <label className="col-sm-auto col-form-label"
                                                       style={{marginLeft: '10px'}}>사업장명</label>

                                                <input type="text" className="form-control"
                                                       style={{width: '200px'}}
                                                       onChange={ e=> {
                                                           searchParams.set('bizName', e.target.value);
                                                           setSearchParams(searchParams);
                                                       }}
                                                       onKeyDown={e => {
                                                           if (e.key === 'Enter') {
                                                               setPage(1);
                                                               requestSearch();
                                                           }
                                                       }}
                                                       value={bizName}
                                                       placeholder=''/>

                                                <button type="submit" className="btn btn-info float-right"
                                                        style={{width: '80px', marginLeft:'10px', marginRight: '20px'}}
                                                        onClick={ () => {
                                                            setPage(1);
                                                            requestSearch();
                                                        }}>
                                                    검색
                                                </button>
                                            </div>
                                        </div>
                                        <div className="card-body table-responsive p-0" style={{marginTop: '20px'}}>
                                            <table className="table table-hover text-nowrap"
                                                   style={{textAlign: "center"}}>
                                                <thead>
                                                <tr>
                                                    <th>SEQ</th>
                                                    <th>사업장명</th>
                                                    <th>사업자번호</th>
                                                    <th>대상 년월</th>
                                                    <th>상태</th>
                                                    <th>비고</th>
                                                    <th>동기화 시간</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {
                                                    contents && contents.map(item => {
                                                        return (
                                                            <tr key={item.id}>
                                                                <td>{item.id}</td>
                                                                <td>{item.bizName}</td>
                                                                <td>{formatBusinessNumber(item.bizNo)}</td>
                                                                <td>{formatYearMonth(item.targetMonth)}</td>
                                                                <td>{item.status}</td>
                                                                <td>{item.message}</td>
                                                                <td>{formatDate(item.batchedAt)}</td>
                                                            </tr>
                                                        )
                                                    })
                                                }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {
                            paginationDto && <Pagination pager={paginationDto} setPage={setPage}/>
                        }

                    </section>

                </div>
            </div>
        </div>
    );
}

export default Main;
